import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCodesandboxComponent } from './simple-icons-codesandbox.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCodesandboxComponent ],
    exports:      [ SimpleIconsCodesandboxComponent ],
    bootstrap:    []
})
export class SimpleIconsCodesandboxModule {}
